/** AWS's logo URL. Kept separate from `aws`'s registration since
 * `aws-midc` and `aws-oidc` also use it. */
export const AwsIconUrl =
  "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Amazon_Web_Services_2025.svg/960px-Amazon_Web_Services_2025.svg.png";
